module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.103/css/toolsmenu.css"